<div class="body flex">
  @for(col of cols; let colIndex = $index; track col.name){

  <div class="column">
    @for(row of rows; let rowIndex = $index; track row.id){

    <div
      class="col"
      [attr.type]="'grouped'"
      [ngClass]="{
            last: colIndex === (cols.length - 1),
            'no-border':
              (rows.length - 1) === rowIndex
                ? false
                : tableFormatter.verticalSpan(tableData,rowIndex, colIndex) > 1
                  ? false
                  : rows[rowIndex + 1].value[colIndex] ===
                    row.value[col.name],
            collapsed: tableFormatter.verticalSpan(tableData,rowIndex, colIndex) === 0,
          }"
      [ngStyle]="{
            '--span': tableFormatter.verticalSpan(tableData,rowIndex, colIndex),
          }"
      [attr.span]="tableFormatter.verticalSpan(tableData, rowIndex, colIndex)"
          [attr.title]="col.type === 'group' || col.dataType === 'link' ? null : row.value[col.name]"
    >
      <div>
            @if(col.type === 'single' && col.dataType === 'link'){
            <div class="link-cell">
              @for (attachment of tableContext.getAttachmentValues(row.value[col.name]); track attachment) {
              <div class="link-entry">
                <span class="link-name" [title]="tableContext.getAttachmentName(attachment)">
                  {{ tableContext.getAttachmentName(attachment) }}
                </span>
                <span class="link-actions">
                  <a
                    class="link-action"
                    [href]="tableContext.resolveAttachmentUrl(attachment)"
                    target="_blank"
                    rel="noopener noreferrer"
                    [title]="'Preview ' + tableContext.getAttachmentName(attachment)"
                    (click)="$event.stopPropagation()"
                  >
                    <ng-icon name="OpenInWindow" size="20"></ng-icon>
                  </a>
                </span>
              </div>
              }
            </div>
            } @else if(col.type === 'single'){
            <p class="cell">
              {{ row.value[col.name] }}
            </p>
        } @if(col.type === 'group'){
        <app-group-cols [col]="col" [rowIndex]="rowIndex" />
        }
      </div>
    </div>
    }
  </div>
  }
</div>
